import { useExperimentTreatment } from '@ms/yammer-experiments-context';
import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import { ErrorBoundary } from '@ms/yammer-relay/dist/components/ErrorBoundary';
import type { ComponentType, FC } from 'react';
import React from 'react';

import type { HomeFeedSwitcherProps } from './HomeFeedSwitcher';

const HomeFeedSwitcher = () => import(/* webpackChunkName: "4-feat-homefeed-switcher" */ './HomeFeedSwitcher');

const LazyHomeFeedSwitcher: ComponentType<HomeFeedSwitcherProps> = lazyLoadOnRender({ loader: HomeFeedSwitcher });
const renderEmptyFallback = () => null;

const LoadableHomeFeedSwitcher: FC<HomeFeedSwitcherProps> = (props) => {
  const isDiscoveryMtoHubHomeFeedEnabled = useExperimentTreatment('DiscoveryMtoHubHomeFeed');

  if (!isDiscoveryMtoHubHomeFeedEnabled) {
    return <LazyHomeFeedSwitcher {...props} />;
  }

  return (
    <ErrorBoundary name="HomeFeedSwitcher" onRenderError={renderEmptyFallback}>
      <LazyHomeFeedSwitcher {...props} />
    </ErrorBoundary>
  );
};

export default LoadableHomeFeedSwitcher;
